import './StatusBadge.css';

export const StatusBadge = ({ status, text }) => {
  const getStatusClass = () => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'status-badge-pending';
      case 'overdue':
        return 'status-badge-overdue';
      case 'paid':
      case 'active':
        return 'status-badge-paid';
      case 'unpaid':
        return 'status-badge-unpaid';
      case 'completed':
        return 'status-badge-completed';
      case 'draft':
        return 'status-badge-overdue';
      default:
        return 'status-badge-default';
    }
  };

  const displayText = text || status || 'Unknown';

  return (
    <span className={`status-badge ${getStatusClass()}`}>
      {displayText}
    </span>
  );
};
